import { ModelBase } from "../abstract/model-base.model";
import { AnalyticalCarrierStatus } from "./analytical-carrier-status.model";

/** Complétude analytique d'un document (endpoint document-status). */
export class AnalyticalDocumentStatus extends ModelBase {

    static override CLASS_NAME: string = 'AnalyticalDocumentStatus';

    private _carriers!: AnalyticalCarrierStatus[];
    private _complete!: boolean;

    public get carriers(): AnalyticalCarrierStatus[] {
        return this._carriers;
    }

    public set carriers(value: any) {
        this._setValue('_carriers', value, 'AnalyticalCarrierStatus');
    }

    public get complete(): boolean {
        return this._complete;
    }

    public set complete(value: any) {
        this._setValue('_complete', value, 'boolean');
    }
}
